import { render, staticRenderFns } from "./LabelManage.vue?vue&type=template&id=996cce82&scoped=true&"
import script from "./LabelManage.vue?vue&type=script&lang=js&"
export * from "./LabelManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996cce82",
  null
  
)

export default component.exports